import { reactive } from 'vue'

/**
 * Stato della mappa/ricerca della Home condiviso a livello di modulo:
 * sopravvive allo smontaggio della view quando si naviga verso il
 * dettaglio di una stazione e si torna indietro (altrimenti Home.vue
 * viene rimontata da zero e perde zoom/pan/filtro).
 */
export const homeMapState = reactive({
  search: '',
  center: null,
  zoom: null,
})
